export default __webpack_public_path__ + "static/media/azure.bd7495b3.svg";